function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import parseUrl from 'url-parse';
import Cookies from 'js-cookie';
var TUNE_S2S_OFFER_COOKIE_PREFIX = 'bt-tune-';
var funnelId = null;
var currentUrl = parseUrl(window.location.href, true);

if (!currentUrl) {
  logCatchJs('[HasOffers] Current URL does not have value.  Did parseUrl() fail?');
}

var _ref = currentUrl.query || {},
    tuneAffiliateRef = _ref.utm_source,
    tuneOfferId = _ref.utm_offer,
    tuneTransactionId = _ref.tune_transaction_id;

try {
  funnelId = getFunnelId(window.location.href);
  logCatchJs('[HasOffers] S2S detected this funnel', {
    funnelId: funnelId
  });

  if (tuneOfferId || tuneTransactionId) {
    logCatchJs("[HasOffers] URL contains utm_offer (".concat(tuneOfferId, ") or tune_transaction_id (").concat(tuneTransactionId, ")"));
    setFunnelCookie(funnelId, {
      tuneAffiliateRef: tuneAffiliateRef,
      tuneOfferId: tuneOfferId,
      tuneTransactionId: tuneTransactionId
    });
  } else {
    var funnelAttr = getFunnelCookie(funnelId) || {};
    tuneAffiliateRef = funnelAttr.tuneAffiliateRef || tuneAffiliateRef;
    tuneOfferId = funnelAttr.tuneOfferId || tuneOfferId;
    tuneTransactionId = funnelAttr.tuneTransactionId || tuneTransactionId;
  }
} catch (err) {
  logCatchJs('[HasOffers] Exception occurred detecting Tune URL attributes', {
    err: err
  });
  throw err;
}
/**
 * Appends Tune Conversion parameters to the given cart attributes array.
 * This is used for carts created via the Storefront API on sales lander pages.
 * @param {Array.<AttributeInput>} attributes
 */


export function appendTuneAttributes(attributes) {
  if (!tuneOfferId) {
    console.log('[HasOffers] No offer id detected; Skipping offer tracking');
    return;
  }

  if (!tuneTransactionId) {
    console.log('[HasOffers] No transaction id detected; Skipping offer tracking');
    return;
  }

  attributes.push({
    key: 'tune_offer_id',
    value: tuneOfferId
  });
  attributes.push({
    key: 'tune_transaction_id',
    value: tuneTransactionId
  });

  if (tuneAffiliateRef) {
    attributes.push({
      key: 'tune_affiliate_ref',
      value: tuneAffiliateRef
    });
  }

  logCatchJs('[HasOffers] Appending Tune attributes to lander cart', {
    tuneAffiliateRef: tuneAffiliateRef,
    tuneOfferId: tuneOfferId,
    tuneTransactionId: tuneTransactionId
  });
  removeFunnelCookie(funnelId);
}
/**
 * Returns Tune Conversion parameters, so they can be added to a Shopify cart
 * @returns {{attributes: {tune_transaction_id: *, tune_offer_id: *, tune_affiliate_ref: *}} | null}
 */

export function getTuneAttributesForShopifyCart() {
  if (!tuneOfferId) {
    console.log('[HasOffers] No offer id detected; Skipping offer tracking');
    return null;
  }

  if (!tuneTransactionId) {
    console.log('[HasOffers] No transaction id detected; Skipping offer tracking');
    return null;
  } // Tune affiliate ref is not required to fire the conversion postback to Tune,
  // but let's keep track of when this value is missing.


  if (!tuneAffiliateRef) {
    logCatchJs('[HasOffers] Affiliate ref is missing', {
      tuneAffiliateRef: tuneAffiliateRef,
      tuneOfferId: tuneOfferId,
      tuneTransactionId: tuneTransactionId
    });
  }

  logCatchJs('[HasOffers] Appending Tune attributes to Shopify cart', {
    tuneAffiliateRef: tuneAffiliateRef,
    tuneOfferId: tuneOfferId,
    tuneTransactionId: tuneTransactionId
  });
  removeFunnelCookie(funnelId);
  /* eslint-disable camelcase */

  return {
    attributes: {
      tune_offer_id: tuneOfferId,
      tune_transaction_id: tuneTransactionId,
      tune_affiliate_ref: tuneAffiliateRef || '__MISSING__'
    }
  };
  /* eslint-enable camelcase */
}
/**
 * Returns the Tune Conversion parameters stored in a cookie for the given funnel.
 * @param funnel
 * @returns {{}|*}
 */

function getFunnelCookie(funnel) {
  if (!funnel) {
    logCatchJs('[HasOffers] Funnel Id missing, unable to retrieve S2S cookie', {
      funnel: funnel
    });
    return {};
  }

  var key = "".concat(TUNE_S2S_OFFER_COOKIE_PREFIX).concat(funnel);

  try {
    logCatchJs('[HasOffers] Getting Tune funnel cookie', {
      cookieKey: key
    });
    var value = Cookies.getJSON(key);
    logCatchJs('[HasOffers] Retrieved Tune funnel cookie', {
      cookieKey: key,
      cookieValue: value
    });
    return value;
  } catch (err) {
    logCatchJs('[HasOffers] Failed to get Tune funnel cookie', {
      cookieKey: key,
      err: err
    });
    throw err;
  }
}
/**
 * Sets the Tune Conversion parameters in a cookie for the given funnel.
 * @param funnel
 * @param value
 */


function setFunnelCookie(funnel, value) {
  if (!funnel) {
    logCatchJs('[HasOffers] Funnel Id missing, S2S cookie will not be set', {
      funnel: funnel
    });
    return;
  }

  var key = "".concat(TUNE_S2S_OFFER_COOKIE_PREFIX).concat(funnel);

  try {
    var cookieAttr = {
      expires: 1,
      domain: getCookieDomain(window.location)
    };
    logCatchJs('[HasOffers] Setting Tune funnel cookie', {
      cookieKey: key,
      cookieValue: value,
      cookieAttr: cookieAttr
    });
    Cookies.set(key, value, cookieAttr);
  } catch (err) {
    logCatchJs('[HasOffers] Failed to set Tune funnel cookie', {
      cookieKey: key,
      cookieValue: value,
      err: err
    });
    throw err;
  }
}
/**
 * Removes the Tune Conversion parameters in a cookie for the given funnel.
 * @param funnel
 */


function removeFunnelCookie(funnel) {
  if (!funnel) {
    logCatchJs('[HasOffers] Funnel Id missing, S2S cookie will not be removed', {
      funnel: funnel
    });
    return;
  }

  var key = "".concat(TUNE_S2S_OFFER_COOKIE_PREFIX).concat(funnel);

  try {
    var cookieAttr = {
      domain: getCookieDomain(window.location)
    };
    logCatchJs('[HasOffers] Removing Tune funnel cookie', {
      cookieKey: key,
      cookieAttr: cookieAttr
    });
    Cookies.remove(key, cookieAttr);
  } catch (err) {
    logCatchJs('[HasOffers] Failed to remove Tune funnel cookie', {
      cookieKey: key,
      err: err
    });
    throw err;
  }
}
/**
 * Returns the domain to use when writing the cookie.
 * This mirrors AffiliateNetworksTracker in TrackersJS.  This was most likely due to BT Checkout
 * (on secure.biotrust.com) but has the side effect of staging cookies ending up in live.
 */


function getCookieDomain(location) {
  var hostname = location.hostname;
  var domain = hostname;

  if (hostname !== null && hostname !== void 0 && hostname.endsWith('biotrust.com')) {
    domain = 'biotrust.com';
  }

  return domain || 'biotrust.com';
}
/**
 * Returns the funnel id from the given URL.
 * @param {string} url
 * @returns {string|null}
 */


function getFunnelId(url) {
  var parsedURL = parseUrl(url); // eslint-disable-next-line no-warning-comments
  // TODO: still need to consider storefront offers

  if (parsedURL.pathname.startsWith('/pages/')) {
    var _parsedURL$pathname$s;

    var pageSlug = (_parsedURL$pathname$s = parsedURL.pathname.split('/').filter(function (part) {
      return part.trim();
    }).pop()) === null || _parsedURL$pathname$s === void 0 ? void 0 : _parsedURL$pathname$s.trim();

    if (pageSlug) {
      return pageSlug;
    }
  }

  return null;
}
/**
 * Logs the given message and object to CatchJS, if enabled.
 * @param message
 * @param logObj
 */


function logCatchJs(message) {
  var _window$bt, _window$bt$settings, _window$btDataLayer, _window$catchjs;

  var logObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  console.log(message, logObj);

  if (!((_window$bt = window.bt) !== null && _window$bt !== void 0 && (_window$bt$settings = _window$bt.settings) !== null && _window$bt$settings !== void 0 && _window$bt$settings.hasOffersLoggingEnabled)) {
    return;
  }

  var cookieErr = null;
  var sessionId = (_window$btDataLayer = window.btDataLayer) === null || _window$btDataLayer === void 0 ? void 0 : _window$btDataLayer.sessionId;

  if (!sessionId) {
    try {
      var _window$bt2, _window$bt2$settings;

      sessionId = Cookies.get((_window$bt2 = window.bt) === null || _window$bt2 === void 0 ? void 0 : (_window$bt2$settings = _window$bt2.settings) === null || _window$bt2$settings === void 0 ? void 0 : _window$bt2$settings.sessionCookieName);
    } catch (ex) {
      sessionId = 'failed-to-read-session-cookie';
      cookieErr = ex;
    }
  }

  var objToLog = _objectSpread(_objectSpread({}, logObj), {}, {
    ts: Date.now()
  });

  if (cookieErr) {
    objToLog.cookieErr = cookieErr;
  } // eslint-disable-next-line no-unused-expressions


  (_window$catchjs = window.catchjs) === null || _window$catchjs === void 0 ? void 0 : _window$catchjs.log("".concat(message, " (cpSessionId: ").concat(sessionId || 'not-set', ")"), objToLog);
}